/**
 * Mirror of React src/config/certificateRules.ts
 * In-house certificates only on Cuty / Cubix bracelets at 0.05 and 0.10 ct.
 * All other products / carats are IGI-only.
 */
(function (window) {
  "use strict";

  var IN_HOUSE_CARATS = { "0.05": true, "0.10": true };

  function normalizeCaratKey(carat) {
    var raw = String(carat || "")
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/ct$/i, "");
    var num = parseFloat(raw);
    if (Number.isNaN(num)) return raw;
    return num.toFixed(2);
  }

  function allowsInHouseCertificate(productKey, carat) {
    var key = String(productKey || "").toLowerCase();
    if (key !== "cuty" && key !== "cubix") return false;
    return Boolean(IN_HOUSE_CARATS[normalizeCaratKey(carat)]);
  }

  /**
   * Hide In-house option when not allowed; keep the same toggle UI (no separate badge).
   * Options root: .ll-cuty-options or .ll-cubix-options
   */
  function applyCutyCubixCertUi(options) {
    var productKey = options.productKey || "cuty";
    var isNecklace = Boolean(options.isNecklace);
    var carat = options.carat || "";
    var root =
      options.root ||
      document.querySelector(".ll-cuty-options, .ll-cubix-options");
    if (!root) return { igiOnly: true };

    var allowInHouse =
      !isNecklace && allowsInHouseCertificate(productKey, carat);
    var igiOnly = !allowInHouse;

    var inhouseLabels = root.querySelectorAll("[data-ll-inhouse-cert]");
    var igiRadio = root.querySelector('input[name="ll_custom_cert"][value="IGI"]');
    var preview = root.querySelector(
      "#ll-cuty-cert-preview, #ll-cubix-cert-preview"
    );

    inhouseLabels.forEach(function (el) {
      el.style.display = igiOnly ? "none" : "";
    });

    if (igiOnly && igiRadio) {
      igiRadio.checked = true;
    } else if (allowInHouse && options.forceDefaultInHouse) {
      var inhouseRadio = root.querySelector(
        'input[name="ll_custom_cert"][value="In-house"], input[name="ll_custom_cert"][value="In house"]'
      );
      if (inhouseRadio) inhouseRadio.checked = true;
    }

    if (preview) {
      var checked = root.querySelector('input[name="ll_custom_cert"]:checked');
      var showPreview = igiOnly || (checked && checked.value === "IGI");
      if (window.LoveLabCertUI && typeof window.LoveLabCertUI.setPreview === "function") {
        window.LoveLabCertUI.setPreview(preview, showPreview);
      } else {
        preview.style.display = showPreview ? "flex" : "none";
      }
    }

    return { igiOnly: igiOnly, allowInHouse: allowInHouse };
  }

  window.LoveLabCertRules = {
    normalizeCaratKey: normalizeCaratKey,
    allowsInHouseCertificate: allowsInHouseCertificate,
    applyCutyCubixCertUi: applyCutyCubixCertUi,
  };
})(window);
